/* ============================================================================
   HORIZON EDITIONS · COLLECTORS LIST FORM
   assets/he-collectors-form.js
   ----------------------------------------------------------------------------
   Progressive enhancement for snippets/collectors-list-form.liquid.
   Single-field (email) Klaviyo client-subscribe + SI-17 analytics hook.

   Pattern mirrors he-international.js / he-nominate.js:
     · validates email before any network call
     · submits to Klaviyo client subscribe (status 202) when data-list-id
       and a resolved company_id are present
     · DEMO MODE if neither configured → confirm locally, never throw
     · on success: reveal [data-collectors-success], hide form, fire
       SI-17 join_collectors_list event
     · on failure: re-enable submit, show inline error
     · idempotent (form.__heColBound guard) for shopify:section:load
   ============================================================================ */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_REVISION = '2024-10-15';

  function initForm(form) {
    if (form.__heColBound) return;
    form.__heColBound = true;

    var wrapper = form.closest('[data-collectors-list-form]');
    var successEl = wrapper && wrapper.querySelector('[data-collectors-success]');
    var emailEl   = form.querySelector('input[name="email"]');
    var submitBtn = form.querySelector('.collectors-list-form__submit');

    var klaviyoListId    = form.getAttribute('data-list-id') || '';
    var klaviyoCompanyId = form.getAttribute('data-company-id')
                        || window.HE_KLAVIYO_COMPANY_ID
                        || '';
    var contextTag = form.getAttribute('data-context-tag') || 'source_collectors_list_form';

    // ── Inline error (lightweight; the collectors snippet has no
    //    dedicated error slot, so we reuse the email input's
    //    aria-invalid + an injected sibling .he-form__error span). ──
    var errEl;
    function showError(msg) {
      if (!emailEl) return;
      emailEl.setAttribute('aria-invalid', 'true');
      if (!errEl) {
        errEl = document.createElement('span');
        errEl.className = 'collectors-list-form__error';
        errEl.setAttribute('role', 'alert');
        errEl.style.color = '#a00';
        errEl.style.fontSize = '0.85em';
        errEl.style.display = 'block';
        errEl.style.marginTop = '4px';
        emailEl.parentNode.appendChild(errEl);
      }
      errEl.textContent = msg;
    }
    function clearError() {
      if (emailEl) emailEl.removeAttribute('aria-invalid');
      if (errEl) errEl.textContent = '';
    }

    function showSuccess() {
      form.hidden = true;
      if (successEl) successEl.hidden = false;
    }
    function fail(msg) {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.__label || submitBtn.textContent;
      }
      showError(msg);
    }

    function submitKlaviyo(email) {
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email, properties: { source: contextTag } }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: klaviyoListId } }
          }
        }
      };
      var url = KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(klaviyoCompanyId);
      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': KLAVIYO_REVISION
        },
        body: JSON.stringify(body)
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();
      var email = emailEl ? (emailEl.value || '').trim() : '';
      if (!EMAIL_RE.test(email)) {
        showError('Enter a valid email address.');
        if (emailEl) emailEl.focus();
        return;
      }

      // DEMO MODE — nothing configured: confirm locally.
      if (!klaviyoListId || !klaviyoCompanyId) {
        showSuccess();
        fireAnalytics();
        return;
      }

      if (submitBtn) {
        submitBtn.__label = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
      }

      submitKlaviyo(email)
        .then(function (res) {
          if (!res.ok && res.status !== 202) {
            throw new Error('Request failed: ' + res.status);
          }
          showSuccess();
          fireAnalytics();
        })
        .catch(function () {
          fail('Something went wrong. Please try again, or email hello@horizoneditionsstudio.com');
        });
    });

    function fireAnalytics() {
      // SI-17 · HE Analytics · success-side event. Defensive: analytics
      // module may be absent; try/catch keeps submit path bulletproof.
      try {
        if (window.HE && typeof window.HE.track === 'function') {
          window.HE.track('join_collectors_list', {
            source: contextTag || 'collectors-list-page',
            list_id: klaviyoListId
          });
        }
      } catch (e) {}
    }

    if (emailEl) emailEl.addEventListener('input', clearError);
  }

  function init() {
    var forms = document.querySelectorAll('[data-collectors-list-form] form[data-klaviyo-form]');
    Array.prototype.forEach.call(forms, initForm);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
